import { render, staticRenderFns } from "./BlockStatusEl.vue?vue&type=template&id=418bf14c&scoped=true&"
import script from "./BlockStatusEl.vue?vue&type=script&lang=ts&"
export * from "./BlockStatusEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418bf14c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
